export default __webpack_public_path__ + "static/media/customers.d90a1171.csv";